import * as e from "react";
const t = (a) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...a
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 2a11 11 0 100 22 11 11 0 000-22zm0 20.167a9.167 9.167 0 110-18.334 9.167 9.167 0 010 18.334z",
      fill: "#121215"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 14.832a5.152 5.152 0 00-4.464 2.75.92.92 0 001.595.917 3.355 3.355 0 012.87-1.834A3.354 3.354 0 0114.87 18.5a.916.916 0 001.523.113.917.917 0 00.072-1.03A5.152 5.152 0 0012 14.832zM8.333 12.085a1.833 1.833 0 100-3.667 1.833 1.833 0 000 3.667zM15.665 12.085a1.833 1.833 0 100-3.667 1.833 1.833 0 000 3.667z",
      fill: "#121215"
    }
  )
), l = t;
export {
  l as default
};
